module.exports = __webpack_public_path__ + "static/img/moaInstallForMac_pic11.020b7b3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/moaInstallForMac/moaInstallForMac_pic11.png
// module id = 529
// module chunks = 1